import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=7eccaeb6"
import script from "./Section.ts?vue&type=script&lang=ts&external"
export * from "./Section.ts?vue&type=script&lang=ts&external"
import style0 from "./Section.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports